<template>
  <button
    v-if="sidebarDock.canToggle.value"
    v-tooltip.bottom="label"
    type="button"
    :aria-label="label"
    class="flex items-center border-r border-gray-200 px-3 text-gray-500 transition-colors duration-150 hover:bg-gray-100 hover:text-gray-700"
    @click="sidebarDock.isExpanded.value = !sidebarDock.isExpanded.value"
  >
    <Icon
      :name="
        sidebarDock.isExpanded.value
          ? 'panel-left-close-lucide'
          : 'panel-left-open-lucide'
      "
      class="size-4.5"
    />
  </button>
</template>

<script setup lang="ts">
import { computed } from "vue";
import Icon from "@/components/Core/Icon.vue";
import { useShellDocks } from "@/composables/useShellDocks";

const { sidebarDock } = useShellDocks();
const label = computed(() =>
  sidebarDock.isExpanded.value ? "Collapse menu" : "Expand menu",
);
</script>
